// extracted by mini-css-extract-plugin
module.exports = {"TabMenu":"TabMenu_TabMenu__1Wxep","Action":"TabMenu_Action__1Qz4e","Content":"TabMenu_Content__2vz4m","active":"TabMenu_active__3emn5","Tab":"TabMenu_Tab__2NoR0"};